'use strict';

var getNormalizedIndex = require('./getNormalizedIndex');

function entryAtIndex(obj, index, length, loop, isString) {
  index = getNormalizedIndex(index, length, loop);
  return isString ? obj.charAt(index) : obj[index];
}

module.exports = entryAtIndex;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/common/internal/entryAtIndex.js
// module id = 444
// module chunks = 0